export const FileType = {
    "Undefined": 0,
    "User": 1,
    "Project": 2,
    "Asset": 3,
    "Company": 4,
    "Office": 5,
    "Call_Action_Internal": 6,
    "Call_Action_External": 7,
    "Knowledgebase": 8,
    "Company_Logo": 9,
    "Login_Image": 10,
    "Banner_Image": 11,
    "Report_Image": 12,
    "Call_Template_Action": 13,
    "Project_Template": 14,
    "Email_Parser": 15,
    "Profile_Image": 16,
    "Email_Action_Template": 17,
    "Timesheet": 18,
    "Nav": 19,
    "Chat": 20,
    "Login_Background": 21,
    "Internal_Background": 22,
    "SSI_Background": 23,
    "User_Background": 24,
    "Team_Banner_Logo": 25,
    "Team_Report_Logo": 26,
    "Company_Type_Logo": 27,
    "Company_Type_Chat_Logo": 28
}